import React from "react";
import { GlobalStyles } from "@mui/material";
import { focusRingSx } from "../../../styles/focusRing";

// Mounted only by Globo Marca routes: MUI draws no focus outline on ButtonBase/Checkbox/Select by default.
const styles = {
  [[
    ".MuiButtonBase-root:focus-visible",
    "a:focus-visible",
    "[role='combobox']:focus-visible",
    "input[type='checkbox']:focus-visible",
    "[tabindex='0']:focus-visible",
  ].join(", ")]: focusRingSx,

  // programmatic focus targets (not tabbable) don't need a ring
  "[tabindex='-1']:focus": { outline: "none" },

  "@media (prefers-reduced-motion: reduce)": {
    ".MuiSkeleton-root, .MuiSkeleton-root::after": {
      animation: "none !important",
    },
    ".MuiCollapse-root, .MuiCard-root, .MuiDialog-container, .MuiBackdrop-root, .MuiDrawer-paper, .MuiPopover-paper":
      {
        transition: "none !important",
      },
  },
};

const A11yGlobalStyles = () => <GlobalStyles styles={styles} />;

export default A11yGlobalStyles;
